export default __webpack_public_path__ + "static/media/empty-folder.ebf47185.png";